import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService, sendAPIRequestOptions } from './api.service';

@Injectable()
export class UserDataService {

	public constructor(
		private api: ApiService,
		private router: Router
	) {}

	// user status properties
	public isLoggedIn: boolean = false;
	public isAdmin: boolean = false;

	// javascript web token
	public jwt(token?: string) {
		if(token === undefined) {
			return localStorage.getItem('jwt');
		}
		else {
			return localStorage.setItem('jwt', token);
		}
	}

	// get profile object in localStorage
	public whoami(profile?: any) {
		if(profile === undefined) {
			return JSON.parse(localStorage.getItem('user.profile'));
		}
		else {
			return localStorage.setItem('user.profile', JSON.stringify(profile));			
		}
	}

	// login
	public login(data: any) {
		return this.api.sendApiRequest('post', 'user/login',  data, { suppressToken: true })
		.toPromise()
		.then(res => {
			let json = res.json();
			this.jwt(json.token);
			this.profile.view();

			return;
		});
	}

	// logout
	public logout() {
		return new Promise(resolve => {
			this.jwt(null);
			this.whoami(null);
			this.isLoggedIn = false;

			this.router.navigate(['/login'])
			.then(() => resolve());
		});
	}

	// own profile
	public profile = {
		view: () => {
			return this.api.sendApiRequest('get', `user/profile`)
			.toPromise()
			.then(res => {
				let profile = res.json();
				this.whoami(profile);
				this.isLoggedIn = true;
				this.isAdmin = profile.type? profile.type.indexOf('super') > -1: false;

				//console.log('user profile', profile);
				return;
			});
		},
		
		update: (data: any) => this.api.sendApiRequest('put', `user/profile`, data)
	};

	// create user
	public create(data: any) {
		return this.api.sendApiRequest('post', `user`, data).toPromise();
	}

	// view user
	public view(id: string | number) {
		return this.api.sendApiRequest('get', `user/${id}`).toPromise();
	}

	// update user
	public edit(id: string | number,data: any) {
		return this.api.sendApiRequest('put', `user/${id}`, data).toPromise();
	}

	// delete user
	public delete(id: string | number) {
		return this.api.sendApiRequest('delete', `user/${id}`).toPromise();
	}

	// list all users
	public list() {
		return this.api.sendApiRequest('get', 'user').toPromise();
	}

	// user password
	public password = {
		update: (data: any) => this.api.sendApiRequest('post', 'user/password/change', data),
		reset: () => this.api.sendApiRequest('get', 'user/password/reset')
	}

}


// WEBPACK FOOTER //
// ./src/services/data.users.service.ts